// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { bufferLikeGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    secretHash: bufferLikeGuard,
    userAgent: z.string().nullable().optional(),
    ip: z.string().nullable().optional(),
    country: z.string().max(16).nullable().optional(),
    city: z.string().nullable().optional(),
    createdAt: z.number().optional(),
    lastUsedAt: z.number().optional(),
    expiresAt: z.number(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    secretHash: bufferLikeGuard,
    userAgent: z.string().nullable(),
    ip: z.string().nullable(),
    country: z.string().max(16).nullable(),
    city: z.string().nullable(),
    createdAt: z.number(),
    lastUsedAt: z.number(),
    expiresAt: z.number(),
});
export const TrustedDevices = Object.freeze({
    table: 'trusted_devices',
    tableSingular: 'trusted_device',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        userId: 'user_id',
        secretHash: 'secret_hash',
        userAgent: 'user_agent',
        ip: 'ip',
        country: 'country',
        city: 'city',
        createdAt: 'created_at',
        lastUsedAt: 'last_used_at',
        expiresAt: 'expires_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'userId',
        'secretHash',
        'userAgent',
        'ip',
        'country',
        'city',
        'createdAt',
        'lastUsedAt',
        'expiresAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
